export const claimsAdviceClaimLineAdjustmentHistoryColumns = [
  'id',
  'fk_payment_id',
  'fk_claim_advice_meta_data_id',
  'claim_number',
  'claim_line_item_control_number',
  'contract_obligation_adjustment_reason_code',
  'contract_obligation_adjustment_amount',
  'contract_obligation_adjustment_quantity',
  'patient_responsibility_adjustment_reason_code',
  'patient_responsibility_adjustment_amount',
  'patient_responsibility_adjustment_quantity',
  'patient_initiated_reduction_reason_code',
  'patient_initiated_reduction_amount',
  'patient_initiated_quantity',
  'medical_procedure_identifier',
  'original_medical_procedure_identifier',
  'line_item_charge_amount',
  'line_item_provider_payment_amount',
  'adjudicated_revenue_code',
  'procedure_code_quantity',
  'service_date_time_qualifier',
  'service_date',
  'other_adjustment_reason_code',
  'other_adjustment_amount',
  'other_adjustment_quantity',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
];
